import { t } from "i18next";

import { Box, Button, Stack, Typography } from "@mui/material";

import { theme } from "@/src/theme/theme";

import BaanaLogo from "@/src/components/atoms/BaanaLogo/BaanaLogo";

interface RouteErrorViewProps {
  title: string;
  message: string;
  showRetry?: boolean;
  showBackToBlog?: boolean;
}

const handleRetry = () => {
  window.location.reload();
};

// Branded, on-brand fallback for the root ErrorBoundary. Intentionally avoids
// the real Header/Footer (which depend on auth/router/data that may be the
// source of the crash) and uses anchors instead of <Link> so navigation works
// even when the router is in a broken state.
const RouteErrorView = ({
  title,
  message,
  showRetry = true,
  showBackToBlog = false
}: RouteErrorViewProps) => {
  return (
    <Box
      sx={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        bgcolor: theme.palette.background.default
      }}
    >
      <Box
        sx={{
          bgcolor: theme.palette.semantic.primary.main,
          px: [2, 3],
          py: 1.5
        }}
      >
        <Box
          component="a"
          href="/"
          aria-label="Baana"
          sx={{ display: "inline-block", width: 110 }}
        >
          <BaanaLogo color={theme.palette.background.paper} />
        </Box>
      </Box>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
          py: 6
        }}
      >
        <Stack
          spacing={3}
          alignItems="center"
          sx={{ maxWidth: 480, textAlign: "center" }}
        >
          <Typography variant="h1" sx={{ fontSize: [28, 36] }}>
            {title}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {message}
          </Typography>
          <Stack
            direction={["column", "row"]}
            spacing={2}
            sx={{ width: "100%", justifyContent: "center" }}
          >
            {showRetry && (
              <Button variant="contained" color="primary" onClick={handleRetry}>
                {t("general.retry")}
              </Button>
            )}
            {showBackToBlog && (
              <Button
                variant="outlined"
                color="primary"
                component="a"
                href="/blog"
              >
                {t("general.backToBlog")}
              </Button>
            )}
            <Button
              variant={showBackToBlog ? "text" : "outlined"}
              color="primary"
              component="a"
              href="/"
            >
              {t("general.backToHome")}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default RouteErrorView;
